<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item :label="$t('bankName')">
          <el-input
            v-model="queryForm.bankName"
            size="small"
            :placeholder="$t('bankName')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isLoading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-row class="table-btns">
        <el-button
          type="text"
          size="mini"
          icon="el-icon-edit"
          @click="editBank()"
          >{{ $t("Adding a Bank Account") }}</el-button
        >
      </el-row>
    </div>
    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isLoading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          prop="bankName"
          fixed="left"
          :label="$t('bankName')"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.bankName }}</template>
        </el-table-column>
        <el-table-column
          prop="bankAccount"
          :label="$t('bankAccount')"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.bankAccount }}</template>
        </el-table-column>
        <el-table-column
          prop="accountAmount"
          :label="$t('accountAmount')"
          width="180"
        >
          <template slot-scope="scope">
            <span class="franc">₣</span
            >{{ scope.row.accountAmount.formatMoney(0) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="accountMaintenanceFees"
          :label="$t('accountMaintenanceFees')"
          width="200"
        >
          <template slot-scope="scope">{{
            scope.row.accountMaintenanceFees.formatMoney(0)
          }}</template>
        </el-table-column>
        <el-table-column
          prop="bankAddress"
          :label="$t('bankAddress')"
          width="160"
        >
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.bankAddress }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('status')" width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0" class="text-success">{{
              $t("normal")
            }}</span>
            <span v-if="scope.row.status == 1" class="text-danger">{{
              $t("lock")
            }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="orgType" :label="$t('businessLicenseCode')" width="220"></el-table-column> -->
        <el-table-column
          prop="createId"
          :label="$t('createId')"
          width="220"
        ></el-table-column>
        <el-table-column prop="remark" :label="$t('remark')" width="220">
          <template slot-scope="scope">
            <div class="overstep-hidden">{{ scope.row.remark }}</div>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          :label="$t('createTime')"
          width="200"
        >
          <template slot-scope="scope">{{
            $manba(scope.row.createTime).format("ymdhms")
          }}</template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('extend')" width="300">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              @click="onLock(scope.row, 1)"
              size="mini"
              type="primary"
              >{{ $t("lock") }}</el-button
            >
            <el-button
              v-if="scope.row.status == 1"
              @click="onLock(scope.row, 0)"
              size="mini"
              type="warning"
              >{{ $t("unlock") }}</el-button
            >
            <el-button
              size="mini"
              @click="editBank(scope.row)"
              type="primary"
              >{{ $t("edit") }}</el-button
            >
            <el-button
              size="mini"
              @click="feedBank(scope.row)"
              type="success"
              >{{ $t("feed") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total || 0"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />

    <el-drawer
      :title="$t(bankForm.type === 0 ? 'addAccount' : 'editAccount')"
      :visible.sync="editBankdrawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="bankForm" :rules="rules" ref="bankForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('bankName')" prop="bankName">
              <el-input
                size="medium"
                v-model="bankForm.bankName"
                :placeholder="$t('bankName')"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('bankAccount')" prop="bankAccount">
              <el-input
                size="medium"
                v-model="bankForm.bankAccount"
                :placeholder="$t('bankAccount')"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$t('bankAddress')" prop="bankAddress">
              <el-input
                size="medium"
                v-model="bankForm.bankAddress"
                :placeholder="$t('bankAddress')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="bankForm.type == 0">
            <el-form-item :label="$t('accountAmount')" prop="accountAmount">
              <el-input
                size="medium"
                v-model="bankForm.accountAmount"
                :placeholder="$t('Initial amount')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-else>
            <el-form-item :label="$t('accountAmount')" prop="accountAmount">
              <el-input
                size="medium"
                v-model="bankForm.accountAmount"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$t('accountMaintenanceFees')"
              prop="accountMaintenanceFees"
            >
              <el-input
                size="medium"
                v-model="bankForm.accountMaintenanceFees"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$t('remark')" prop="remark">
              <el-input
                size="medium"
                type="textarea"
                rows="3"
                v-model="bankForm.remark"
                :placeholder="$t('remark')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item class="bottom-button">
          <el-button
            v-if="bankForm.id"
            size="medium"
            type="primary"
            @click="updateSubmit('bankForm')"
            :loading="isloading"
            >{{ $t("submit") }}</el-button
          >
          <!-- <el-button v-else size="medium" type="primary" @click="addSubmit('businessForm')" :loading="isloading">{{$t('submit')}}</el-button>
          -->
          <el-button
            v-else
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="addSubmit('bankForm')"
            >{{ $t("submit") }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>

    <el-drawer
      :title="$t('feed') + ' - ' + (bankForm.bankName || '')"
      :visible.sync="feedBankdrawer"
      direction="rtl"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="480"
    >
      <div class="drawer-content">
        <div class="bank-summary">
          <div class="summary-row">
            <span class="summary-label">{{ $t("bankName") }}</span>
            <span class="summary-value">{{ bankForm.bankName }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">{{ $t("bankAccount") }}</span>
            <span class="summary-value">{{ bankForm.bankAccount }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">{{ $t("bankAddress") }}</span>
            <span class="summary-value">{{ bankForm.bankAddress }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-label">{{ $t("accountAmount") }}</span>
            <span class="summary-value amount">
              ₣
              {{
                bankForm.accountAmount
                  ? bankForm.accountAmount.formatMoney(0)
                  : "0"
              }}
            </span>
          </div>
        </div>

        <el-divider content-position="left">{{ $t("newAmount") }}</el-divider>

        <el-form
          :model="feedForm"
          :rules="feedRules"
          ref="feedForm"
          label-position="top"
        >
          <el-form-item :label="$t('newAmount')" prop="applyAmount">
            <el-input
              size="medium"
              v-model="applyAmountDisplay"
              :placeholder="$t('newAmount')"
              @input="onApplyAmountInput"
            >
              <template slot="prepend">FCFA</template>
            </el-input>
          </el-form-item>

          <el-form-item :label="$t('remark')" prop="applyRemark">
            <el-input
              size="medium"
              type="textarea"
              :rows="3"
              v-model="feedForm.applyRemark"
              :placeholder="$t('remark')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="medium"
              style="width:100%"
              :loading="isloading"
              @click="feedSubmit('feedForm')"
              >{{ $t("submit") }}</el-button
            >
          </el-form-item>
        </el-form>

        <el-divider content-position="left">{{ $t("feedHistory") }}</el-divider>

        <el-table
          :data="feedApplyTableData.records"
          v-loading="isApplyLoading"
          size="mini"
          style="width:100%"
        >
          <el-table-column
            prop="applyAmount"
            :label="$t('amount')"
            min-width="110"
          >
            <template slot-scope="scope">
              <span class="franc">FCFA</span
              >{{ scope.row.applyAmount.formatMoney(0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="applyTime"
            :label="$t('creationTime')"
            min-width="140"
          >
            <template slot-scope="scope">
              {{ $manba(scope.row.applyTime).format("ymdhms") }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          small
          background
          layout="total,prev,pager,next"
          :total="feedApplyTableData.total || 0"
          :page-size="feedApplyPageSize"
          :current-page="feedApplyCurrentPage"
          @current-change="setFeedApplyCurrentChange"
          style="margin-top:8px;text-align:right"
        />
      </div>
    </el-drawer>

    <!-- 锁定/解锁账户弹框 -->

    <el-drawer
      :title="
        $t(lockAccount.form.status == 1 ? 'lockAccount' : 'unlockAccount')
      "
      :visible.sync="lockAccount.drawer"
      :direction="'rtl'"
      :modal="false"
      :destroy-on-close="true"
      :wrapperClosable="false"
      :size="700"
    >
      <el-form :model="lockAccount.form" :rules="rules" ref="lockAccount">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('bankName')">
              <el-input
                v-model="lockAccount.row.bankName"
                size="small"
                disabled
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('id')" style="display: none;">
              <el-input v-model="lockAccount.row.id"></el-input>
            </el-form-item>

            <el-form-item :label="$t('bankAccount')">
              <el-input
                v-model="lockAccount.row.bankAccount"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('accountAmount')">
              <el-input
                v-model="lockAccount.row.accountAmount"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('accountMaintenanceFees')">
              <el-input
                v-model="lockAccount.row.accountMaintenanceFees"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('bankAddress')">
              <el-input
                v-model="lockAccount.row.bankAddress"
                size="small"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="bottom-button">
        <el-button
          size="medium"
          type="primary"
          :loading="isLoading"
          @click="onSubmitLock('lockAccount')"
          >{{
            $t(lockAccount.form.status == 1 ? "lockAccount" : "unlockAccount")
          }}</el-button
        >
      </div>
    </el-drawer>
  </el-card>
</template>
<script>
import bank from "@/api/bank";
export default {
  name: "bankAccount",
  data() {
    return {
      queryForm: {},
      //table高度，动态设置
      queryTableHeight: String,
      //table显示内容
      tableData: {},
      //分页器默认参数
      pageSize: 20,
      currentPage: 1,
      //显示加载中
      isLoading: false,
      applyAmountDisplay: "",
      //右侧弹框
      editBankdrawer: false,
      feedBankdrawer: false,
      bankForm: { type: 1 },

      //addForm: { },
      lockAccount: {
        drawer: false,
        form: {},
        row: {}
      },

      feedForm: {},
      feedApplyTableData: {},
      feedApplyPageSize: 20,
      feedApplyCurrentPage: 1,
      isApplyLoading: false,
      isloading: false
    };
  },
  computed: {
    rules() {
      return {
        bankName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        bankAddress: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        accountAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ],
        accountMaintenanceFees: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    },
    //imgError () { return this.$store.state.system.imgError; },

    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },

    feedRules() {
      return {
        applyAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  methods: {
    /**查询列表 */
    getList() {
      let _this = this;
      _this.isLoading = true;
      bank.getBankPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          ..._this.queryForm
        },
        success: res => {
          _this.tableData = res.data || {};
          _this.isLoading = false;
        }
      });
    },
    onApplyAmountInput(val) {
      const raw = String(val || "")
        .replace(/\s/g, "")
        .replace(/[^\d]/g, "");
      this.applyAmountDisplay = raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      this.$set(this.feedForm, "applyAmount", raw);
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    /**格式化地区 */

    //drawerOpen () { this.drawer = true; },
    /**提交新增新机构 */

    onLock(row, status) {
      console.log(row);
      row.userName = row.name + " " + row.surname;

      this.lockAccount.row = row;
      this.lockAccount.form = { id: row.id, status: status };
      this.lockAccount.drawer = true;
    },
    editBank(data) {
      let _this = this;
      _this.bankForm = { type: 0 };
      if (data) _this.bankForm = data;
      _this.editBankdrawer = true;
    },

    addSubmit(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.isLoading = true;
          //_this.bankForm.id = _this.bankForm.id || 0;
          bank.addBankAccount({
            param: _this[formName],
            success: res => {
              if (res.code === 200) {
                _this.$message({
                  type: "success",
                  message: _this.$t("operateSuccessfully")
                });
                _this.editBankdrawer = false;
                _this.getList();
              } else
                _this.$message({ type: "warning", message: _this.$t(res.msg) });
              _this.isLoading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    updateSubmit(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.isloading = true;
          bank.updateById({
            param: _this[formName],
            success: res => {
              if (res.code == 200) {
                _this.$message({
                  type: "success",
                  message: _this.$t("operateSuccessfully")
                });
                _this.getList();
                _this.editBankdrawer = false;
              } else {
                _this.$message({ type: "warning", message: _this.$t(res.msg) });
              }
              _this.isloading = false;
            }
          });
        }
      });
    },

    feedBank(data) {
      this.bankForm = data || {};
      this.feedForm = {};
      this.applyAmountDisplay = "";
      this.feedApplyCurrentPage = 1;
      this.feedBankdrawer = true;
      this.getFeedHistory(data.id);
    },
    getFeedHistory(bankId) {
      this.isApplyLoading = true;
      bank.getFeedBankHistory({
        param: {
          current: this.feedApplyCurrentPage,
          size: this.feedApplyPageSize,
          bankId
        },
        success: res => {
          this.feedApplyTableData = res.data || {};
          this.isApplyLoading = false;
        }
      });
    },
    setFeedApplyCurrentChange(val) {
      this.feedApplyCurrentPage = val;
      this.getFeedHistory(this.bankForm.id);
    },
    feedSubmit(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (!valid) return;
        _this.isloading = true;
        bank.feedBankById({
          param: { ..._this.feedForm, bankId: _this.bankForm.id },
          success: res => {
            if (res.code == 200) {
              _this.$message.success(_this.$t("operateSuccessfully"));
              _this.feedForm = {};
              _this.getList();
              _this.getFeedHistory(_this.bankForm.id);
            } else {
              _this.$message.warning(_this.$t(res.msg));
            }
            _this.isloading = false;
          }
        });
      });
    },
    onSubmitLock(refName) {
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        bank.updateBankStatus({
          param: this.lockAccount.form,
          success: res => {
            if (res.code == 200) {
              this.getList();
              this.lockAccount.drawer = false;
              this.$message.success(this.$t("operateSuccessfully"));
            } else this.$message.warning(this.$t(res.msg));
          }
        });
      });
    }
  },

  created() {},
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.drawer-content {
  padding: 20px;
  .bank-summary {
    background: #f5f7fa;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
    .summary-row {
      display: flex;
      justify-content: space-between;
      padding: 6px 0;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border-bottom: none;
      }
      .summary-label {
        color: #909399;
        font-size: 13px;
      }
      .summary-value {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        &.amount {
          color: #409eff;
          font-size: 15px;
        }
      }
    }
  }
}
</style>
